// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__QO-_n","productName":"Table_productName__2IweM"};